<section class="dark-card">
  <header class="dark-card__header">
    <div>
      <h4>{{ title }}</h4>
      <p>{{ subtitle }} · {{ timestamp }}</p>
    </div>
    <div class="dark-card__chip">{{ completionPercent.toFixed(1) }}%</div>
  </header>

  <div class="dark-card__hero">
    <div class="metric">
      <small>Objetivo total</small>
      <strong>{{ summary.obj | number:'1.0-0' }}</strong>
    </div>
    <div class="metric">
      <small>Aprobados</small>
      <strong>{{ summary.aprobados | number:'1.0-0' }}</strong>
    </div>
  </div>

  <div class="dark-card__progress">
    <i [style.width.%]="completionPercent"></i>
  </div>

  <div class="dark-card__rows">
    @for (row of rows; track row.name) {
      <article class="row">
        <div class="row__meta">
          <span>{{ row.name }}</span>
          <b>{{ (row.cumplimiento * 100).toFixed(1) }}%</b>
        </div>
        <div class="row__nums">
          <small>{{ row.aprobados | number:'1.0-0' }} / {{ row.obj | number:'1.0-0' }}</small>
        </div>
        <div class="row__bar">
          <i [style.width.%]="rowPercent(row.cumplimiento)"></i>
        </div>
      </article>
    }
  </div>
</section>
